import { toggleExternalSource } from "api/ExternalSource";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useToggleExternalSource = () => {
    const queryClient = useQueryClient();

    return useMutation(toggleExternalSource, {
        onSuccess: () => {
            toast.success("Changed successfully!");

            queryClient.invalidateQueries('external-sources')
        },
        onError: (error: any) => {
            toast.error(error.response.data.message || 'Something went wrong')
        },
    })
}